import React from 'react'
import BannerPrueba from '../../../Assets/equifax 1920x450.png'
import BannerMobile from '../../../Assets/Business. Handsome Manager Working on Laptop, Holding Computer and Looking at Camera, Standing over White Background - Editada.jpg'
import { Button } from 'antd'

function Banner() {


  const isMobile = window.innerWidth < 768


  return (
    <div className='w-full relative'>
      {
        !isMobile ?
          <>
            <div className='absolute md:top-20 2xl:top-32 left-32 text-black text-center text-3xl flex flex-col gap-3'>
              <p className=''>
                Decisiones inteligentes y <br />
                cobranzas efectivas para <br />
                fortalecer tu negocio
              </p>
              <Button
                className='bg-red-700 text-2xl py-7 text-white w-full rounded-full'
                onClick={() => document.getElementById('form').scrollIntoView({ behavior: 'smooth' })}
              >
                Contactanos
              </Button>
            </div>
            <img src={BannerPrueba} alt='Banner' className='w-full md:h-[300px] 2xl:h-[400px] object-cover object-top' />
          </>
          :
          <div className='flex flex-col gap-5'>
            <img src={BannerMobile} alt='Banner' className='w-full md:h-[400px] 2xl:h-[600px] object-cover object-center' />
            <div className='text-black text-center text-xl flex flex-col gap-3 px-5 md:px-0'>
              <p className=''>
                Decisiones inteligentes y 
                cobranzas efectivas para 
                fortalecer tu negocio
              </p>
              <Button
                className='bg-red-700 text-2xl py-7 text-white w-full rounded-full'
                onClick={() => document.getElementById('form').scrollIntoView({ behavior: 'smooth' })}
              >
                Contactanos
              </Button>
            </div>
          </div>
      }
    </div>
  )
}

export default Banner